import { Stack, Typography, Box, Container } from "@mui/material"
import { ContainedButton } from "../../../../../components/Button"
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { FacebookIcon } from "../../../../../components/icons/FacebookIcon"
import { XIcon } from "../../../../../components/icons/XIcon"
import { InstagramIcon } from "../../../../../components/icons/InstagramIcon"

export const ResultCta = () => {
  return (
    <Container maxWidth="lg" sx={{ px: { xs: 3, md: 8 } }}>
      <Box
        sx={{
          background: '#09364E',
          borderRadius: '16px',
          padding: { xs: '24px 16px', md: '32px' },
          textAlign: 'center',
          mb: 4
        }}
      >
        <Stack spacing={2} alignItems="center">
          <Typography
            fontSize="24px"
            fontWeight={600}
            color="white"
          >
            Thanks for learning what's in your water!
          </Typography>
          
          <Typography
            fontSize="16px"
            fontWeight={500}
            color="white"
            sx={{ maxWidth: '600px' }}
          >
            Your water test result is ready! Share your findings with friends and help spread awareness about water quality.
          </Typography>

          <ContainedButton
            sx={{ 
              minWidth: '120px',
              mt: 1,
              borderRadius: '40px',
              backgroundColor: 'white !important',
              color: 'text.primary',
              '&:hover': {
                backgroundColor: '#F3F6F8 !important'
              },
              '&:active': {
                backgroundColor: '#F3F6F8 !important'
              }
            }}
            startIcon={<ContentCopyIcon />}
          >
            Copy link
          </ContainedButton>

          <Stack direction="row" spacing={3} sx={{ mt: 2 }}>
            <FacebookIcon sx={{ cursor: 'pointer' }} />
            <XIcon sx={{ cursor: 'pointer' }} />
            <InstagramIcon sx={{  cursor: 'pointer' }} />
          </Stack>
        </Stack>
      </Box>
    </Container>
  )
}